import * as THREE from "three";
/**
 * Sizes
 */
export const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

export const getRandomInt = (max) => {
  return Math.floor(Math.random() * max);
};

export const OBJECT_COUNTS = 700;
export const RANGE_MAX = 10;
export const OFFSET_POSITION = 4;
